import React, { useEffect, useState } from "react";
import { avanzoApi, formatSeconds } from "@/lib/avanzoApi";

export default function AvanzoProfile() {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    avanzoApi.summary().then((r) => setSummary(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="avz-empty">Cargando…</div>;
  if (!summary) return <div className="avz-empty">No pudimos cargar tu perfil.</div>;

  const examDate = new Date(summary.avanzo_exam_date);
  const subjectsPracticed = summary.subjects.filter((s) => s.skills_practiced > 0);

  return (
    <div data-testid="avz-profile">
      <section className="avz-card">
        <h1 className="avz-h1" data-testid="avz-profile-name">
          {summary.student_name || "Estudiante"}
        </h1>
        <p className="avz-mute" data-testid="avz-profile-grade">
          Grado: {summary.grade || "—"}
        </p>
      </section>

      <section className="avz-grid avz-grid-2 avz-mt-4">
        <div className="avz-card">
          <div className="avz-mute">AVANZO</div>
          <div className="avz-h2">
            {examDate.toLocaleDateString("es-SV", { day: "numeric", month: "long", year: "numeric" })}
          </div>
          <p className="avz-mute avz-mt-4" data-testid="avz-profile-days">
            Faltan <span className="avz-strong">{summary.days_until_avanzo}</span> días.
          </p>
        </div>
        <div className="avz-card">
          <div className="avz-mute">Preparación</div>
          <div className="avz-h2" data-testid="avz-profile-overall">
            {summary.overall_progress_label}
          </div>
          <p className="avz-mute avz-mt-4">
            Sesiones realizadas: <span className="avz-strong">{summary.sessions_completed}</span>
          </p>
          <p className="avz-mute">
            Tiempo total de preparación:{" "}
            <span className="avz-strong">{formatSeconds(summary.time_seconds_total)}</span>
          </p>
        </div>
      </section>

      <section className="avz-card avz-mt-4">
        <h3 className="avz-h3">Materias practicadas</h3>
        {subjectsPracticed.length === 0 ? (
          <p className="avz-mute">Estamos empezando a conocerte.</p>
        ) : (
          <div className="avz-stack avz-mt-4">
            {subjectsPracticed.map((s) => (
              <div
                className="avz-skill-row"
                key={s.key}
                data-subject={s.key}
                data-testid={`avz-profile-subject-${s.key}`}
                style={{
                  borderLeft: `4px solid var(--avz-subject-${s.key})`,
                  paddingLeft: 12,
                }}
              >
                <div>
                  <div className="avz-strong" style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span
                      className="avz-subject-dot"
                      aria-hidden="true"
                      style={{ background: `var(--avz-subject-${s.key})` }}
                    />
                    {s.label}
                  </div>
                  <div className="avz-mute">{s.skills_practiced} habilidades</div>
                </div>
                <span className="avz-chip">{s.mastery_label}</span>
              </div>
            ))}
          </div>
        )}
      </section>

      <section className="avz-card avz-mt-4">
        <p className="avz-mute">
          Tiempo disponible hoy: 45 minutos como máximo. Tú decides cuánto usar.
        </p>
      </section>

      <section className="avz-card avz-mt-4" data-testid="avz-profile-help">
        <h3 className="avz-h2">Ayuda</h3>
        <button
          type="button"
          className="avz-btn avz-btn-primary avz-mt-4"
          data-testid="avz-profile-reopen-tour"
          onClick={async () => {
            try { await avanzoApi.paesOnboardingReopen(); } catch { /* noop */ }
            window.dispatchEvent(new Event("avz:onboarding-reopen"));
          }}
          style={{ display: "inline-block" }}
        >
          Ver recorrido de Buddy AVANZA
        </button>
        <p className="avz-mute avz-mt-4">
          Vuelve a ver el tour cuando quieras. No cambia tu progreso.
        </p>
      </section>
    </div>
  );
}
